export default {
    setIndexDocument(state, data){
        state.allDocuments = data;
    },
    reloadIndex(state, bool)
    {
      state.reloadIndex = bool;
    },
    showSigner(state, data){
        state.showSigner = data;
    }
}